{
  "name": "@ns/reactivate-subscription",
  "version": "1.1.0",
  "requiredPermission": "BILLING_MANAGE",
  "description": "Reactivating your nodeStream subscription",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    }
  },
  "outcomes": {
    "cancel": {},
    "complete": {}
  }
}
